import { type RouteObject } from 'react-router'

import {
  CATALOG_BRAND_DETAIL_TRANSACTION_PATH,
  CATALOG_BRANDS_TRANSACTION_PATH,
  CATALOG_DETAIL_URL,
  CATALOG_PRODUCT_DETAIL_TRANSACTION_PATH,
  CATALOG_PRODUCTS_TRANSACTION_PATH,
  CATALOG_SOURCE_DETAIL_TRANSACTION_PATH,
  CATALOG_SOURCES_TRANSACTION_PATH,
  CATALOG_SUBTHEME_DETAIL_TRANSACTION_PATH,
  CATALOG_THEME_DETAIL_TRANSACTION_PATH,
  CATALOG_THEMES_TRANSACTION_PATH,
  CATALOG_TRANSACTION_PATH,
  CATALOG_URL,
} from 'features/catalog/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const catalogPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/catalog/Container'))

export const catalogRoutes: RouteObject[] = [
  {
    path: CATALOG_URL,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_URL,
      sentryTransactionPath: CATALOG_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/brands`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'brands',
      sentryTransactionPath: CATALOG_BRANDS_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/brands/:brandName`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'brands',
      sentryTransactionPath: CATALOG_BRAND_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/products`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'products',
      sentryTransactionPath: CATALOG_PRODUCTS_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/products/:productName`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'products',
      sentryTransactionPath: CATALOG_PRODUCT_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/themes`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'themes',
      sentryTransactionPath: CATALOG_THEMES_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/themes/:themeName`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'themes',
      sentryTransactionPath: CATALOG_THEME_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/themes/:themeName/subthemes/:subThemeName`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'themes',
      sentryTransactionPath: CATALOG_SUBTHEME_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/sources`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'sources',
      sentryTransactionPath: CATALOG_SOURCES_TRANSACTION_PATH,
    },
  },
  {
    path: `${CATALOG_URL}/sources/:sourceName`,
    lazy: catalogPage(),
    handle: {
      featureKey: CATALOG_DETAIL_URL,
      collectionType: 'sources',
      sentryTransactionPath: CATALOG_SOURCE_DETAIL_TRANSACTION_PATH,
    },
  },
]
